/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamPlannerDtoPage } from '../../models/team-planner-dto-page';

export interface ListTeamPlanners$Params {
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'description' | '-description' | 'usersCount' | '-usersCount' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listTeamPlanners(http: HttpClient, rootUrl: string, params?: ListTeamPlanners$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listTeamPlanners.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamPlannerDtoPage>;
    })
  );
}

listTeamPlanners.PATH = '/v0/teamPlanners';
